export default __webpack_public_path__ + "static/media/photo--lg--kara5.cd93a3f2.jpg";